import "core-js/modules/es.function.name.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue";
var _hoisted_1 = {
  "class": "tw-hidden lg:tw-block"
};
var _hoisted_2 = {
  "class": "tw-text-16 tw-font-semibold tw-mb-10px"
};
var _hoisted_3 = ["innerHTML"];
var _hoisted_4 = {
  "class": "tw-mb-10px"
};
var _hoisted_5 = {
  key: 0,
  "class": "tw-mb-10px"
};
var _hoisted_6 = {
  "class": "tw-mb-10px"
};
var _hoisted_7 = {
  "class": "tw-mb-10px"
};
var _hoisted_8 = {
  "class": "tw-mb-10px"
};
var _hoisted_9 = {
  key: 0,
  "class": "tw-text-12 tw-my-10px"
};
var _hoisted_10 = ["innerHTML"];
var _hoisted_11 = ["innerHTML"];
var _hoisted_12 = ["innerHTML"];
var _hoisted_13 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_base_alert = _resolveComponent("base-alert");
  var _component_base_textarea = _resolveComponent("base-textarea");
  var _component_base_input = _resolveComponent("base-input");
  var _component_static_spinner = _resolveComponent("static-spinner");
  var _component_base_button = _resolveComponent("base-button");
  var _component_trustpilot_microstar = _resolveComponent("trustpilot-microstar");
  var _component_contact_agency_success = _resolveComponent("contact-agency-success");
  var _component_limit_modal = _resolveComponent("limit-modal");
  var _component_limit_saved_modal = _resolveComponent("limit-saved-modal");
  var _component_unauthorized_modal = _resolveComponent("unauthorized-modal");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    id: "container-agency-banner",
    "class": "tw-px-20px tw-py-15px tw-bg-w-cultured tw-rounded",
    onClick: _cache[6] || (_cache[6] = function ($event) {
      return _ctx.isTextAreaClicked = true;
    })
  }, [_createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.title), 1 /* TEXT */), _createCommentVNode(" ALERT SUCCESS "), _ctx.success ? (_openBlock(), _createBlock(_component_base_alert, {
    key: 0,
    "alrt-class": "tw-alert-w-primary tw-m-0 tw-w-full"
  }, {
    "default": _withCtx(function () {
      return [_createElementVNode("p", {
        innerHTML: _ctx.labels.messageIsSent + '. ' + _ctx.labels.agencyWillContactYou
      }, null, 8 /* PROPS */, _hoisted_3)];
    }),
    _: 1 /* STABLE */
  })) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createCommentVNode(" CONTACT AGENCY BANNER + ALERT ERROR "), _createElementVNode("div", null, [_createCommentVNode(" ALERT ERROR "), _ctx.errorMessage ? (_openBlock(), _createBlock(_component_base_alert, {
    key: 0,
    "alrt-class": "tw-alert-w-danger tw-m-0 tw-w-full",
    text: "Hai già inviato una richiesta per questo immobile nelle ultime 24 ore."
  })) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createCommentVNode(" CONTACT AGENCY BANNER "), _createElementVNode("form", {
    id: "send_request_banner",
    "class": "tw-flex tw-flex-col h-lg-100",
    onKeydown: _cache[5] || (_cache[5] = function ($event) {
      return _ctx.userInteraction = true;
    })
  }, [_createCommentVNode(" se user è LOGGATO "), _createElementVNode("div", _hoisted_4, [_createVNode(_component_base_textarea, {
    id: "send_request_banner_message",
    modelValue: _ctx.textareaMessage,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.textareaMessage = $event;
    }),
    "label-text": _ctx.labelTextarea,
    rows: "3",
    value: _ctx.textareaMessage,
    "is-valid": _ctx.textareaMessage.length > 0,
    feedback: {
      valid: "",
      invalid: "Inserisci un messaggio"
    },
    required: "true"
  }, null, 8 /* PROPS */, ["modelValue", "label-text", "value", "is-valid"])]), _createCommentVNode(" se user è SLOGGATO "), !_ctx.isUserLogged && _ctx.isTextAreaClicked ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createCommentVNode(" NAME "), _createElementVNode("div", _hoisted_6, [_createVNode(_component_base_input, {
    id: "send_request_banner_name",
    modelValue: _ctx.v$.name.$model,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return _ctx.v$.name.$model = $event;
    }),
    type: "text",
    "for": "send_request_banner_name",
    name: "name",
    "label-text": _ctx.labels.name,
    "is-valid": _ctx.isValid(_ctx.v$.name),
    required: "true"
  }, null, 8 /* PROPS */, ["modelValue", "label-text", "is-valid"])]), _createCommentVNode(" EMAIL "), _createElementVNode("div", _hoisted_7, [_createVNode(_component_base_input, {
    id: "send_request_banner_email",
    modelValue: _ctx.v$.email.$model,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
      return _ctx.v$.email.$model = $event;
    }),
    type: "text",
    "for": "send_request_banner_email",
    name: "email",
    "label-text": _ctx.labels.email,
    "is-valid": _ctx.isValid(_ctx.v$.email),
    feedback: {
      valid: '',
      invalid: 'Inserisci email valida'
    },
    required: "true"
  }, null, 8 /* PROPS */, ["modelValue", "label-text", "is-valid"])]), _createCommentVNode(" PHONE "), _createElementVNode("div", _hoisted_8, [_createVNode(_component_base_input, {
    id: "send_request_banner_phone",
    modelValue: _ctx.v$.phone.$model,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
      return _ctx.v$.phone.$model = $event;
    }),
    type: "tel",
    "for": "send_request_banner_phone",
    name: "phone",
    "label-text": _ctx.labels.phone,
    "is-valid": _ctx.isValid(_ctx.v$.phone),
    feedback: {
      valid: '',
      invalid: 'Inserisci numero valido'
    }
  }, null, 8 /* PROPS */, ["modelValue", "label-text", "is-valid"])]), _createCommentVNode(" PRIVACY "), !_ctx.isUserLogged ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("span", {
    innerHTML: _ctx.readAndAcceptedByClicking
  }, null, 8 /* PROPS */, _hoisted_10), _createElementVNode("span", {
    innerHTML: _ctx.labels.privacy_policy_generic
  }, null, 8 /* PROPS */, _hoisted_11), _createTextVNode(" ("), _createElementVNode("a", {
    "class": "tw-underline",
    href: "#",
    onClick: _cache[4] || (_cache[4] = _withModifiers(
    //@ts-ignore
    function () {
      return _ctx.openPrivacyDisclaimer && _ctx.openPrivacyDisclaimer.apply(_ctx, arguments);
    }, ["prevent"])),
    innerHTML: _ctx.privacy_C_section
  }, null, 8 /* PROPS */, _hoisted_12), _createTextVNode(") ")])) : _createCommentVNode("v-if", true)])) : _createCommentVNode("v-if", true), _createElementVNode("div", null, [_createVNode(_component_base_button, {
    "data-cy": "send-message-btn",
    "btn-class": "tw-btn-w-primary tw-btn-sm tw-flex tw-w-full tw-justify-center tw-items-center",
    disabled: _ctx.isUserLogged && !_ctx.areInputsValid || _ctx.isTextAreaClicked && !_ctx.areInputsValid,
    onClick: _withModifiers(_ctx.submitForm, ["prevent"])
  }, {
    "default": _withCtx(function () {
      return [_createElementVNode("span", {
        innerHTML: _ctx.endedAuction ? _ctx.labels.requestInfos : _ctx.labels.sendMessage
      }, null, 8 /* PROPS */, _hoisted_13), _ctx.isSubmitting ? (_openBlock(), _createBlock(_component_static_spinner, {
        key: 0,
        thickness: 10,
        "class": "tw-mr-5px"
      })) : _createCommentVNode("v-if", true)];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["disabled", "onClick"]), _createVNode(_component_trustpilot_microstar, {
    "class": "tw-mt-25px"
  })])], 32 /* NEED_HYDRATION */)], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))])], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))]), _ctx.show ? (_openBlock(), _createBlock(_component_contact_agency_success, {
    key: 0,
    "config-options": _ctx.successModalConfig,
    "activate-reload-cb": _ctx.loginSuccess,
    data: _ctx.successModalData,
    "is-contract-type-sale": _ctx.agencyData.sale && !_ctx.agencyData.rent && !_ctx.agencyData.auction,
    "wikicasa-news-url": _ctx.wikicasaUrl,
    labels: {
      request_sent: _ctx.labels.request_sent,
      request_sent_correctly_2: _ctx.labels.request_sent_correctly_2,
      additional_services: _ctx.labels.additional_services,
      select_options: _ctx.labels.select_options,
      similar_properties_in_email: _ctx.labels.similar_properties_in_email,
      mail_alert_mobile: _ctx.labels.mail_alert_mobile,
      send_generic_request: _ctx.labels.send_generic_request,
      send_generic_request_2: _ctx.labels.send_generic_request_2,
      mortgage_request: _ctx.labels.mortgage_request,
      mortgage_request_2: _ctx.labels.mortgage_request_2,
      phone: _ctx.labels.phone,
      news_request: _ctx.labels.news_request,
      news_request_1: _ctx.labels.news_request_1,
      news_request_2: _ctx.labels.news_request_2,
      newsletter_mobile: _ctx.labels.newsletter_mobile,
      confirm: _ctx.labels.confirm
    },
    icons: {
      close: _ctx.icons.closeIcon,
      facile1x: _ctx.icons.facile1x,
      facile2x: _ctx.icons.facile2x,
      crediPass: _ctx.icons.crediPass
    },
    name: _ctx.name,
    "show-modal": _ctx.success,
    onClosedModal: _cache[7] || (_cache[7] = function ($event) {
      return _ctx.show = false;
    }),
    onShowErrorModal: _ctx.handleShowErrorModal
  }, null, 8 /* PROPS */, ["config-options", "activate-reload-cb", "data", "is-contract-type-sale", "wikicasa-news-url", "labels", "icons", "name", "show-modal", "onShowErrorModal"])) : _ctx.errorCode === 412 ? (_openBlock(), _createBlock(_component_limit_modal, {
    key: 1,
    "show-modal": true,
    "close-icon": _ctx.icons.closeIcon,
    labels: {
      title: _ctx.labels.limitModalTitle,
      reached_limit: _ctx.labels.reached_limit,
      sign_in: _ctx.labels.sign_in
    },
    onOpenSigninModal: _ctx.openSigninModal
  }, null, 8 /* PROPS */, ["close-icon", "labels", "onOpenSigninModal"])) : _ctx.errorCode === 405 || _ctx.errorCode === 409 ? (_openBlock(), _createBlock(_component_limit_saved_modal, {
    key: 2,
    "show-modal": true,
    "close-icon": _ctx.icons.closeIcon,
    labels: {
      title: _ctx.labels.generic_error,
      limit_saved: _ctx.errorCode === 405 ? _ctx.labels.limit_saved_not_logged : _ctx.labels.limit_saved_logged
    }
  }, null, 8 /* PROPS */, ["close-icon", "labels"])) : _ctx.errorCode === 401 ? (_openBlock(), _createBlock(_component_unauthorized_modal, {
    key: 3,
    "show-modal": true,
    "close-icon": _ctx.icons.closeIcon,
    labels: {
      title: _ctx.labels.unauthorizedTitle,
      unauthorized: _ctx.labels.unauthorized,
      login: _ctx.labels.login
    },
    onOpenLoginModal: _ctx.openLoginModal
  }, null, 8 /* PROPS */, ["close-icon", "labels", "onOpenLoginModal"])) : _createCommentVNode("v-if", true)]);
}